import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, alertController, modalController } from "@ionic/vue";
import { translate } from '@hotwax/dxp-components';
import { flashOutline, stopCircleOutline, timeOutline } from 'ionicons/icons'
import { useStore } from "vuex";
import { computed } from "vue";
import { RuleService } from "@/services/RuleService";
import { hasError, showToast } from "@/utils";
import logger from "@/logger";
import RuleGroupHistoryModal from '@/components/RuleGroupHistoryModal.vue';
import { popoverController } from "@ionic/core";
import emitter from "@/event-bus";


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleActionsPopover',
  setup(__props) {

const store = useStore();
const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);

async function disableRuleGroup() {
  const payload = {
    ruleGroupId: ruleGroup.value.ruleGroupId,
    paused: "Y",
    systemMessageRemoteId: "RemoteSftp"
  }

  emitter.emit("presentLoader");
  try {
    const resp = await RuleService.scheduleRuleGroup(payload)
    if(!hasError(resp)){
      const ruleGroupValue = JSON.parse(JSON.stringify(ruleGroup.value))
      ruleGroupValue.schedule.paused = "Y"
      store.dispatch("rule/updateRuleGroup", ruleGroupValue)
      showToast(translate("Rule group disabled successfully."))
      popoverController.dismiss();
    } else {
      throw resp.data
    }
  } catch(err) {
    showToast(translate("Failed to disable rule group."))
    logger.error(err)
  }
  emitter.emit("dismissLoader");
}

async function openRuleGroupHistoryModal() {
  const groupHistoryModal = await modalController.create({
    component: RuleGroupHistoryModal
  })

  await popoverController.dismiss();
  groupHistoryModal.present();
}

async function runNow() {
  const scheduleAlert = await alertController
    .create({
      header: translate("Run now"),
      message: translate("Running this schedule now will not replace this schedule. A copy of this schedule will be created and run immediately. You may not be able to reverse this action."),
      buttons: [
        {
          text: translate("Cancel"),
          role: "cancel",
        },
        {
          text: translate("Run now"),
          handler: async () => {
            emitter.emit("presentLoader");
            // Checking that if we already have the job schedule before calling runNow, because if the job scheduler is not present then runNow action can't be performed
            // If the scheduler for the job is available then we will have jobName, if not then first scheduling the job in draft status just to create a routing schedule and then calling runNow action
            if(!ruleGroup.value.jobName) {
              const payload = {
                ruleGroupId: ruleGroup.value.ruleGroupId,
                paused: "Y",  // passing Y as we just need to configure the scheduler and do not need to schedule it in active state
                // Hardcoding for now, need to fetch system message remote id for the ftp server config.
                systemMessageRemoteId: "RemoteSftp"
              }

              try {
                const resp = await RuleService.scheduleRuleGroup(payload)
                if(hasError(resp)) {
                  throw resp.data
                }
              } catch(err) {
                logger.error(err)
                emitter.emit("dismissLoader");
                return;
              }
            }

            try {
              const resp = await RuleService.runNow(ruleGroup.value.ruleGroupId)
              if(!hasError(resp) && resp.data.jobRunId) {
                showToast(translate("Service has been scheduled."))
                await store.dispatch('rule/fetchRules', { groupTypeEnumId: ruleGroup.value.groupTypeEnumId, pageSize: 50 })
                popoverController.dismiss();
              } else {
                throw resp.data
              }
            } catch(err) {
              showToast(translate("Failed to schedule service."))
              logger.error(err)
            }
            emitter.emit("dismissLoader");
          }
        }
      ]
    });

  await scheduleAlert.present();
  popoverController.dismiss()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonListHeader), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)("More options")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openRuleGroupHistoryModal()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: _unref(timeOutline)
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("History")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (runNow()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: _unref(flashOutline)
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Run now")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), {
            button: "",
            lines: "none",
            disabled: !ruleGroup.value.schedule || (ruleGroup.value.schedule?.paused === 'Y'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (disableRuleGroup()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "start",
                icon: _unref(stopCircleOutline),
                color: "danger"
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonLabel), { color: "danger" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Disable")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})